export default __webpack_public_path__ + "static/media/check-mark-black.8d5ec5e4.svg";